var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBrokenRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23743_26225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 2.66634V1.33301M9.99967 13.333V14.6663M2.66634 5.99967H1.33301M13.333 9.99967H14.6663M3.27582 3.27582L2.33301 2.33301M12.7235 12.7235L13.6663 13.6663M7.99967 11.7709L6.58546 13.1851C5.54406 14.2265 3.85562 14.2265 2.81422 13.1851C1.77283 12.1437 1.77283 10.4553 2.81422 9.41389L4.22844 7.99967M11.7709 7.99967L13.1851 6.58546C14.2265 5.54406 14.2265 3.85562 13.1851 2.81422C12.1437 1.77283 10.4553 1.77283 9.41389 2.81423L7.99967 4.22844",
    stroke: "#F0665E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23743_26225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBrokenRed);
export default __webpack_public_path__ + "static/media/link-broken-red.f79c5557844770e177eeb42d548ab0ff.svg";
export { ForwardRef as ReactComponent };